import passwords from './passwords'

export default [
	{
		path: '/verfiy/signature/:identifier',
		name: null,
	},
	{
		path: '/2fa',
		name: null,
	},
	{
		path: '/auth/magic-login/:user',
		name: null,
	},
	...passwords,
]
